<template>
     <base-section id="pricing" space="20">
          <v-container>
               <v-row justify="space-between">
                    <v-col cols="12" md="12" class="text-center">
                         <base-section-heading title="Services">
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, sed do eiusmod tempor incididunt ut labore
                              et dolore magna aliqua. Ut enim ad minim veniam,
                              quis nostrud exercitation ullamco laboris nisi ut
                              aliquip ex ea commodo consequat.
                         </base-section-heading>
                    </v-col>
               </v-row>
               <div class="pt-8"></div>
               <v-row justify="space-between">
                    <v-col
                         v-for="(card, index) in cards"
                         :key="index"
                         cols="12"
                         sm="4"
                         md="4"
                    >
                         <base-pricing-card
                              :name="card.name"
                              :description="card.description"
                              :price="card.price"
                              :featured="card.featured"
                              :list="card.list"
                         ></base-pricing-card>
                    </v-col>
               </v-row>
          </v-container>
     </base-section>
</template>

<script>
export default {
     name: 'SectionPricing',
     mounted() {
          this.cards = this.demo_cards
     },
     data() {
          return {
               text: 'center',
               toggle_exclusive: 2,
               cards: [],
               demo_cards: [
                    {
                         name: 'Product 1',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$45',
                         list: [
                              'feature 1',
                              'feature 2',
                              'feature 3',
                              'feature 4',
                         ],
                    },
                    {
                         name: 'Product 2',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$55',
                         featured: true,
                         list: [
                              'feature 1',
                              'feature 2',
                              'feature 3',
                              'feature 4',
                         ],
                    },
                    {
                         name: 'Product 3',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$60',
                         list: [
                              'feature 1',
                              'feature 2',
                              'feature 3',
                              'feature 4',
                         ],
                    },
               ],
          }
     },
}
</script>
